var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5152C11.5668 12.5152 15 13.1844 15 15.7687C15 18.3531 11.5448 19 7.5 19C3.4332 19 0 18.3298 0 15.7464C0 13.1621 3.45422 12.5152 7.5 12.5152ZM7.5 0C10.2546 0 12.4626 2.23663 12.4626 5.02684C12.4626 7.81705 10.2546 10.0537 7.5 10.0537C4.74543 10.0537 2.53737 7.81705 2.53737 5.02684C2.53737 2.23663 4.74543 0 7.5 0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1582 5.88835C15.8031 5.53326 15.2288 5.52852 14.8779 5.87941C14.5278 6.22957 14.5318 6.8046 14.8869 7.15969L15.7186 7.99142L14.8693 8.84067C14.5184 9.19156 14.5232 9.76586 14.8783 10.121C15.2334 10.476 15.8077 10.4808 16.1586 10.1299L17.0078 9.28064L17.8403 10.1131C18.1954 10.4682 18.7704 10.4722 19.1206 10.122C19.4714 9.77116 19.4667 9.19686 19.1116 8.84177L18.2791 8.0093L19.1299 7.15859C19.48 6.80843 19.476 6.2334 19.1209 5.87831C18.7658 5.52322 18.1908 5.51921 17.8406 5.86937L16.9899 6.72008L16.1582 5.88835Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsence);
export default __webpack_public_path__ + "static/media/absence.9c4bde574953ff85b8ec6e5f1b488e3f.svg";
export { ForwardRef as ReactComponent };